import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import { z } from 'zod';

export const labMasterTradeWizardRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/trades/master_trades/wizard',
  staticData: { fullScreen: true },
  // The draft's id lives in the URL so a reload keeps the in-progress operation.
  validateSearch: z.object({ master_trade_id: z.coerce.number().optional() }),
}).lazy(() =>
  import('pages/lab/Trades/LabMasterTrades/LabMasterTradeNewPageV3/MasterTradeWizardPage').then(
    (d) => d.Route
  )
);
